// Definition of all permissions in the system
export const PERMISSIONS = {
  CreateUser: "CreateUser",
  UpdateUser: "UpdateUser",
  DeleteUser: "DeleteUser",
  GetUsers: "GetUsers",
  GetUser: "GetUser",
  CreateBank: "CreateBank",
  GetBanks: "GetBanks",
  UpdateBank: "UpdateBank",
  DeleteBank: "DeleteBank",
  GetRoles: "GetRoles",
  CreateRole: "CreateRole",
  UpdateRole: "UpdateRole",
  DeleteRole: "DeleteRole",
  GetRolePermissions: "GetRolePermissions",
  GetPermissions: "GetPermissions",
  AssignRevokePermissions: "AssignRevokePermissions",
  GetAllAccountSubTypes: "GetAllAccountSubTypes",
  GetAccountSubTypeById: "GetAccountSubTypeById",
  CreateAccountSubType: "CreateAccountSubType",
  UpdateAccountSubType: "UpdateAccountSubType",
  DeleteAccountSubType: "DeleteAccountSubType",
  GetAllAccountTypes: "GetAllAccountTypes",
  GetAccountTypeById: "GetAccountTypeById",
  CreateAccountType: "CreateAccountType",
  UpdateAccountType: "UpdateAccountType",
  DeleteAccountType: "DeleteAccountType",
  GetAllChartOfAccounts: "GetAllChartOfAccounts",
  GetAllBanks: "GetAllBanks",
  GetAllExpenses: "GetAllExpenses",
  CreateChartOfAccount: "CreateChartOfAccount",
  UpdateChartOfAccount: "UpdateChartOfAccount",
  GetOneChartOfAccount: "GetOneChartOfAccount",
  DeleteChartOfAccount: "DeleteChartOfAccount",
  GetDeclarations: "GetDeclarations",
  CreateDeclaration: "CreateDeclaration",
  UpdateDeclaration: "UpdateDeclaration",
  DeleteDeclaration: "DeleteDeclaration",
  GetDeclarationById: "GetDeclarationById",
  GetDrivers: "GetDrivers",
  CreateDriver: "CreateDriver",
  UpdateDriver: "UpdateDriver",
  DeleteDriver: "DeleteDriver",
  GetDriverById: "GetDriverById",
  GetInventory: "GetInventory",
  GetInventoryById: "GetInventoryById",
  GetProducts: "GetProducts",
  CreateProduct: "CreateProduct",
  UpdateProduct: "UpdateProduct",
  DeleteProduct: "DeleteProduct",
  GetProductById: "GetProductById",
  GetPurchases: "GetPurchases",
  CreatePurchase: "CreatePurchase",
  GetPurchaseById: "GetPurchaseById",
  UpdatePurchase: "UpdatePurchase",
  DeletePurchase: "DeletePurchase",
  GetSales: "GetSales",
  CreateSale: "CreateSale",
  UpdateSale: "UpdateSale",
  GetSaleById: "GetSaleById",
  DeleteSale: "DeleteSale",
  GetStores: "GetStores",
  CreateStore: "CreateStore",
  UpdateStore: "UpdateStore",
  DeleteStore: "DeleteStore",
  GetStoreById: "GetStoreById",
  GetSuppliers: "GetSuppliers",
  CreateSupplier: "CreateSupplier",
  UpdateSupplier: "UpdateSupplier",
  DeleteSupplier: "DeleteSupplier",
  GetSupplierById: "GetSupplierById",
  GetCaTransactions: "GetCaTransactions",
  CreateCaTransaction: "CreateCaTransaction",
  GetCaTransactionById: "GetCaTransactionById",
  GetCustomers: "GetCustomers",
  CreateCustomer: "CreateCustomer",
  UpdateCustomer: "UpdateCustomer",
  DeleteCustomer: "DeleteCustomer",
  GetCustomerById: "GetCustomerById",
  GetProductCategories: "GetProductCategories",
  CreateProductCategory: "CreateProductCategory",
  UpdateProductCategory: "UpdateProductCategory",
  DeleteProductCategory: "DeleteProductCategory",
  GetTransportCost: "GetTransportCost",
  GetEslCustomCost: "GetEslCustomCost",
  GetTransiFees: "GetTransiFees",
  DeleteDeclarationDetail: "DeleteDeclarationDetail",
  UpdateDeclarationDetail: "UpdateDeclarationDetail",
  CreateDeclarationDetail: "CreateDeclarationDetail",
  GetProvisions: "GetProvisions",
  CreateCustomerPayment: "CreateCustomerPayment",
  GenerateCustomerAgingReport: "GenerateCustomerAgingReport",
  GenerateBankTransactionReport: "GenerateBankTransactionReport",
  CreateSupplierPayment: "CreateSupplierPayment",
  CreateEslCustom: "CreateEslCustom",
  CreateCustomTaxPayment: "CreateCustomTaxPayment",
  CreateTransitPayment: "CreateTransitPayment",
  CreateTransportPayment: "CreateTransportPayment",
  CreateEslPayment: "CreateEslPayment",
  GenerateAPAgingReport: "GenerateAPAgingReport",
  GenerateTransactionWithSplitSummary: "GenerateTransactionWithSplitSummary",
  GenerateTrialBalanceReport: "GenerateTrialBalanceReport",
  GenerateInventoryValuationReport: "GenerateInventoryValuationReport",
  GenerateProfitAndLossReport: "GenerateProfitAndLossReport",
  GenerateBalanceSheetReport: "GenerateBalanceSheetReport",
  GetUnitOfMeasurements: "GetUnitOfMeasurements",
  CreateUnitOfMeasurement: "CreateUnitOfMeasurement",
  UpdateUnitOfMeasurement: "UpdateUnitOfMeasurement",
  DeleteUnitOfMeasurement: "DeleteUnitOfMeasurement",
  CreateJournalEntry: "CreateJournalEntry",
  DeleteJournalEntry: "DeleteJournalEntry",
  DeleteTransportPayment: "DeleteTransportPayment",
  DeleteTransitPayment: "DeleteTransitPayment",
  DeleteEslPayment: "DeleteEslPayment",
  CreateExpensesPayment: "CreateExpensesPayment",
  DeleteExpensesPayment: "DeleteExpensesPayment",
  GetSalesInvoiceNumber: "GetSalesInvoiceNumber",
  GetPurchaseWaybillNumber: "GetPurchaseWaybillNumber",
};
